import script from "./ConnectedNumbersMobileTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectedNumbersMobileTable.vue?vue&type=script&setup=true&lang=js"

import "./ConnectedNumbersMobileTable.vue?vue&type=style&index=0&id=4bcb6670&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bcb6670"]])

export default __exports__